<div class="container">
    <h1>RECTIFICADO DE MOTORES</h1>
    
    <div class="azul" style="text-align: center;">Rectificamos todo tipo de motores y cigueñales</div>
    <div style="text-align: center;"> <img src="assets/imagenes/RECT_MOTORES.gif" width="480" height="360"><img
            src="assets/imagenes/ciguenal.gif" width="480" height="360">
    </div>
</div>